// Copyright (c) 2016 Deere & Company

import NormalClaimContainer from '../../claim/normal/state-connector';

export default {
    component: NormalClaimContainer,
    name: 'NORMAL',
    path: 'normal/new(/:pin)'
};



// WEBPACK FOOTER //
// ./src/routes/claims/normal-claim-route.js